module.exports = {
  PRIVACY_POLICY: 'https://www.extellio.com/resources/documents/privacy-policy',
  TERMS_OF_SERVICE: 'https://www.extellio.com/terms-and-conditions/terms-of-service',
  TERMS_OF_SERVICE_NO_PDA: 'https://www.extellio.com/terms-and-conditions/terms-of-service-nodpa',
  PRICING: 'https://www.extellio.com/pricing',
  PLANS: 'https://www.extellio.com/plans',
  END_USER_TERMS: 'https://www.extellio.com/terms-and-conditions/end-user-terms',
  SUPPORT_ANALYSIS: 'https://www.extellio.com/products/support-and-services',
  KNOWLEDGE_BASE: 'https://www.extellio.com/knowledge-base',
  CONTACT_SUPPORT: 'mailto:contact@extellio.com',
  DIGITAL_ONBOARDING: 'https://academy.extellio.com/digital-onboarding',
  GITHUB: 'https://github.com/extellio/extellio',
  KB_EXPORT_API: 'https://www.extellio.com/post/export-api',
  KB_USER_PERMISSIONS: 'https://www.extellio.com/post/understanding-the-different-user-permissions',
  KB_MASK_ELEMENTS: 'https://www.extellio.com/post/how-to-mask-elements',
  KB_CUSTOM_DIMENSIONS: 'https://www.extellio.com/post/how-to-create-custom-dimensions',
  KB_CAMPAIGN_LINKS: 'https://www.extellio.com/post/how-to-track-campaign-links',
  KB_COOKIES: 'https://www.extellio.com/post/what-cookies-do-extellio-use',
  KB_COOKIELESS_ANALYTICS: 'https://www.extellio.com/post/how-to-turn-on-cookieless-analytics',
  KB_SURVEY_TRIGGERS: 'https://www.extellio.com/post/how-to-write-advanced-triggers-for-your-surveys',
  KB_REGEX_SYNTAX: 'https://www.extellio.com/post/how-to-use-regex',
};
